import React, { useEffect, useState } from "react";
import { Modal } from "react-responsive-modal";
import { useForm } from "react-hook-form";

import {
  calculationBasisOptions,
  calculationTypeOptions,
  calculationFromOptions

} from "../../utils/commonSelectBoxOptions/commonSelectBoxOptions";

const EditSalaryMappingComponent = ({
  openModal,
  onCloseModal,
  salaryComponentData,
  policyData,
  onDraftChange,
}) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const [isFixed, setIsFixed] = useState(false);

  useEffect(() => {
    if (!salaryComponentData) return;

    reset({
      componentName: salaryComponentData.earning_type,
      calculationType: salaryComponentData.calculation_type,
      to_be_calculated_value: salaryComponentData.to_be_calculated_value,
      calculationBasis: salaryComponentData.calculated_from_value,
      calculationFrom: salaryComponentData.calculated_from_value,
    });

    setIsFixed(Boolean(salaryComponentData.is_fixed));
  }, [salaryComponentData]);

  const onSubmit = (data) => {
    const updated = {
      salary_component_id: salaryComponentData.salary_component_id,
      earning_type: salaryComponentData.earning_type,

      calculation_type: Number(data.calculationType),
      to_be_calculated_value: Number(data.to_be_calculated_value),

      calculated_from: data.calculationFrom,

      is_fixed: isFixed,
      component_type: salaryComponentData.component_type,

      template_is_active:
        salaryComponentData.template_is_active === false
          ? false
          : salaryComponentData.template_is_active ?? true,
    };

    onDraftChange(updated);
    onCloseModal();
  };

  return (
    <Modal open={openModal} onClose={onCloseModal} center>
      <div className="p-5 w-[520px]">
        <h2 className="text-lg font-semibold mb-4">Edit Salary Component</h2>

        <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">

          <div>
            <label className="text-sm font-medium">Component Name</label>
            <input
              type="text"
              disabled
              {...register("componentName")}
              className="input-field mt-1 w-full bg-gray-100"
            />
          </div>
          <div>
            <label className="text-sm font-medium">Calculation Type</label>
            <select
              {...register("calculationType", { required: true })}
              className="input-field mt-1 w-full"
            >
              {calculationTypeOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>

            {errors.calculationType && (
              <p className="text-red-500 text-xs mt-1">Required</p>
            )}
          </div>

       
          <div>
            <label className="text-sm font-medium">Caluculation value</label>
            <input
              type="number"
              step="0.01"
              {...register("to_be_calculated_value", { required: true })}
              className="input-field mt-1 w-full"
            />
            {errors.to_be_calculated_value && (
              <p className="text-red-500 text-xs mt-1">Required</p>
            )}
          </div>

          <div>
            <label className="text-sm font-medium">Calculation From</label>

            <select
              {...register("calculationFrom", { required: true })}
              className="input-field mt-1 w-full"
            >
              {calculationFromOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>

            {errors.calculationFrom && (
              <p className="text-red-500 text-xs mt-1">Required</p>
            )}
          </div>

          <div className="flex justify-end gap-3 mt-5">
            <button type="button" className="btn btn--border" onClick={onCloseModal}>
              Cancel
            </button>
            <button type="submit" className="btn">
              Save
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default EditSalaryMappingComponent;
